import Loader from '@pickleballinc/features/src/Loader/Loader';
import { createContext, ReactNode, useContext, useState } from 'react';

interface LoaderContextProps {
  loading: boolean;
  setLoading: (loading: boolean) => void;
}

const LoaderContext = createContext<LoaderContextProps | undefined>(undefined);

export const useLoader = () => {
  const context = useContext(LoaderContext);
  if (!context) {
    throw new Error('useLoader must be used within a LoaderProvider');
  }
  return context;
};

export const LoaderProvider = ({ children }: { children: ReactNode }) => {
  const [loading, setLoading] = useState(false);
  return (
    <LoaderContext.Provider value={{ loading, setLoading }}>
      {loading ? <Loader backgroundColor='bg-leagues-300/90' /> : null}
      {children}
    </LoaderContext.Provider>
  );
};
